import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    warningTitle: translate({ id: 'orders.list.storageIndicator.warning.title' }),
    warningDescription: translate({ id: 'orders.list.storageIndicator.warning.description' }),
    errorTitle: translate({ id: 'orders.list.storageIndicator.error.title' }),
    errorDescription: translate({ id: 'orders.list.storageIndicator.error.description' }),
    fullErrorTitle: translate({ id: 'orders.list.storageIndicator.fullError.title' }),
    fullErrorDescription: translate({ id: 'orders.list.storageIndicator.fullError.description' }),
    linkText: translate({ id: 'orders.list.storageIndicator.error.linkText' }),

    close: translate({ id: 'global.close' }),
  }))

  return api
}
